import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, TextField } from "@material-ui/core";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import _ from "lodash";
import colors from "../../styles/colors";

import { Mixpanel } from "../../mixpanel";
import Config from "../../config";
import { createRequestOptions } from "../../services/utils";
import events from "../../services/events";
import AlertDialog from "./AlertDialog";
import { Link } from "react-router-dom";

const style = {
  headerText: {
    fontFamily: "Poppins-Regular",
    color: colors.primary,
    fontSize: 24,
    margin: 0,
    marginBottom: 10,
    fontWeight: 600,
  },
  text: {
    fontFamily: "Poppins-Regular",
    color: colors.primary,
    fontSize: 16,
    margin: 0,
    fontWeight: 600,
  },
  input: {
    marginBottom: 10,
    fontFamily: "Poppins-Regular",
  },
  modal: {
    borderRadius: 9,
    borderStyle: "solid 2px grey",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignContent: "center",
  },
};

//props -  setIsOpen, appId, providerId,
const AddPatient = (props) => {
  const [open, setOpen] = useState(false);
  const [dateOfEval, setDateOfEval] = useState(null);
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [clientGoal, setClientGoal] = useState("");
  const [phone, setPhone] = useState("");
  const [rtmGoal, setRtmGoal] = useState("");
  const [matrixSize, setMatrixSize] = useState("");
  const [alert, setAlert] = useState({ open: false, title: "", message: "" });

  const handleDateChange = (date) => {
    setDateOfEval(date);
  };

  //Open Diag when parent prop is true
  useEffect(() => {
    if (!open && props.open) {
      setOpen(true);
      setDateOfEval(null);
      setFirstName("");
      setLastName("");
      setClientGoal("");
      setPhone("");
      setRtmGoal("");
      setEmail("");
      setConfirmEmail("");
      setMatrixSize("");
    }
  }, [props.open]);

  //Close Diag and Set Parent Var To Closed As Well
  const closeDiaglog = () => {
    props.close();
    setOpen(false);
  };

  const validateForm = () => {
    if (_.isEmpty(email)) {
      return "Email address is required";
    }
    if (_.isEmpty(confirmEmail)) {
      return "Please confirm the email address";
    }
    if (confirmEmail !== email) {
      return "Email and confirm email must match";
    }
    if (_.isEmpty(firstName)) {
      return "First Name is required";
    }
    if (_.isEmpty(lastName)) {
      return "Last Name is required";
    }

    if (dateOfEval) {
      if (_.isEmpty(phone)) {
        return "Patient phone number is required when using RTM.";
      }
      if (_.isEmpty(rtmGoal)) {
        return "Therapist's goal for patient is required when using RTM.";
      }
    }
    const emailRegex = /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailRegex.test(String(email).toLowerCase())) {
      //valid email address
      return "ok";
    } else {
      return "Invalid email address";
    }
  };

  const inviteUser = () => {
    const valid = validateForm();
    if (valid === "ok") {
      const options = createRequestOptions({
        userId: props.userId,
        appId: props.appId,
        email: email,
        firstName: firstName,
        lastName: lastName,
        reasonForTreatment: null, //Removed
        estimatedTreatments: -1, //Removed
        dateOfEval: dateOfEval ? dateOfEval : null,
        patientGoal: rtmGoal ? rtmGoal : null,
        patientPhone: phone ? phone : null,
        matrixSize: matrixSize ? matrixSize : null,
        text: "You are invited to use this Channel! Please follow the instructions to access it.",
        clientGoal: clientGoal,
      });

      fetch(Config.serverUrl + "/InviteUserToApp", options)
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          events().trackUserEvent(
            "Add Patient",
            props.appId,
            null,
            null,
            null,
            props.userId,
            null,
            "portal",
            props.appName,
            null,
            null
          );

          Mixpanel.track("Invite user", {
            Email: email,
            "Channel Name": props.appName,
            Platform: "Web",
          });

          props.close();
          setOpen(false);

          if (result.response.allowInviteMore) {
            setAlert({
              open: true,
              title: "Success",
              message: "Invitation Sent",
            });
          } else {
            setAlert({
              open: true,
              title: "Patient Limit Reached",
              message:
                <span>
                  Your patient limit has been reached under your current plan. <br /> Please <a href="https://ac-health.com/ac-health-pricing/" target="_blank" rel="noopener noreferrer">click here</a> to view available plans and upgrade your subscription, or reach out to <a href='mailto:info@ac-health.com'>info@ac-health.com</a>.
                </span>,
            });
          }
        })
        .catch((error) => {
          console.error("Error sending invite user email: " + error);
        });
    } else {
      setAlert({ open: true, title: "Validation Error", message: valid });
    }
  };

  return (
    <React.Fragment>
      <AlertDialog
        open={alert.open}
        onClose={() => setAlert({ ...alert, open: false })}
        title={alert.title}
        message={alert.message}
      />
      <Dialog open={open} onClose={() => closeDiaglog()} style={style.modal}>
        <DialogContent>
          <h3 style={style.headerText}>
            Add New Patient/Client - {props.title}
          </h3>
          <div style={style.column}>
            <TextField
              variant="outlined"
              label="Email"
              required
              fullWidth
              value={email}
              style={style.input}
              onChange={(event) => setEmail(event.target.value)}
            />
            <TextField
              variant="outlined"
              label="Confirm Email"
              required
              fullWidth
              value={confirmEmail}
              style={style.input}
              onChange={(event) => setConfirmEmail(event.target.value)}
            />
            <TextField
              variant="outlined"
              label="Client First Name"
              required
              fullWidth
              value={firstName}
              style={style.input}
              onChange={(event) => setFirstName(event.target.value)}
            />
            <TextField
              variant="outlined"
              label="Client Last Name"
              required
              fullWidth
              value={lastName}
              style={style.input}
              onChange={(event) => setLastName(event.target.value)}
            />
            <TextField
              variant="outlined"
              label="Client's Personal Goal"
              fullWidth
              value={clientGoal}
              style={style.input}
              multiline
              maxRows={3}
              onChange={(event) => setClientGoal(event.target.value)}
            />
            <hr />
            <h3 style={style.text}>
              Required For RTM Tracking (Medicare/RTM Only)
            </h3>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="Date Of Eval"
                value={dateOfEval}
                onChange={handleDateChange}
                margin="normal"
                id="date-picker-dialog"
                format="MM/dd/yyyy"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
            {props.app && props.app.matrixSizeEnabled && (
              <TextField
                variant="outlined"
                label="TrabeculeX Matrix Size"
                fullWidth
                style={style.input}
                value={matrixSize}
                onChange={(event) => setMatrixSize(event.target.value)}
              />
            )}
            <TextField
              variant="outlined"
              label="Patient Phone Number"
              fullWidth
              style={style.input}
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
            />
            <TextField
              variant="outlined"
              label="Therapist's Goal For Patient"
              fullWidth
              style={style.input}
              value={rtmGoal}
              maxRows={3}
              onChange={(event) => setRtmGoal(event.target.value)}
            />
            <div style={style.btnRow}>
              <Button
                variant="outlined"
                style={{ marginRight: 10 }}
                onClick={() => closeDiaglog()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{ backgroundColor: colors.primary, color: "white" }}
                onClick={() => {
                  inviteUser();
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default AddPatient;


// WEBPACK FOOTER //
// ./src/components/common/AddPatient.js